module.exports = __webpack_public_path__ + "static/Dominick-ecc31d67f447e7617e416c9b635f4030.jpg";